import React from "react";
import { Menu, Icon, Dropdown } from "semantic-ui-react";
import { Navigation } from "../../routes/Navigation";
import { Link, useNavigate, useLocation } from "react-router-dom";
// import { useAuth } from "../../../hooks";
import {
  PicRightOutlined,
  UserOutlined,
  HomeOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { Layout, Menu as MenuAnt } from "antd";

import "./SideMenu.scss";

export function SideMenu(props) {
  const { children, collapsedMenuAnt } = props;
  const { pathname } = useLocation();
  return (
    <div className={`side-menu-admin${collapsedMenuAnt ? "-colapsed" : ""}`}>
      <MenuLeftAntd pathname={pathname} collapsedMenuAnt={collapsedMenuAnt} />
      <div className="appContent">{children}</div>
    </div>
  );
}

function MenuLeftAntd(props) {
  const { collapsedMenuAnt, pathname } = props;
//   const { auth } = useAuth();
  const { Sider } = Layout;

//   const role = auth.me?.role.toUpperCase();

  const navigate = useNavigate();

  return (
    <Layout>
      <Sider
        width={250}
        style={{
          backgroundColor: "#212225",
          overflow: "auto",
          position: "fixed",
          height: "100vh",
          width: "250px",
          left: 0,
          top: "50px",
          bottom: 0,
        }}
        trigger={null}
        collapsible
        collapsed={collapsedMenuAnt}
      >
        <MenuAnt
          theme={"dark"}
          style={{
            backgroundColor: "#212225",
          }}
          onClick={({ key }) => {
            if (key !== "SUBMENU") {
              navigate(key);
            }
          }}
          mode="vertical"
          defaultSelectedKeys={["/"]}
          selectedKeys={[pathname]}
          items={[
            {
              key: "/notes",
              icon: <HomeOutlined />,
              label: "Notas",
              link: "/notes",
            },
            {
              key: "/destinos",
              icon: <PicRightOutlined />,
              label: "Destinos",
              link: "/destinos",
            },

            {
              key: "/estados",
              icon: <UserOutlined />,
              label: "Estados",
            //   disabled: role === "MASTER" ? false : true,
            //   style: { display: role === "MASTER" ? "" : "none" },
            },
          ]}
        >
          <Navigation />
        </MenuAnt>
      </Sider>
    </Layout>
  );
}
